export const translations = {
  en: {
    tagline: "Auto Locksmith Expert",
    nav: {
      services: "Services",
      about: "About",
      ourWork: "Our Work",
      areas: "Service Areas",
      contact: "Contact"
    },
    hero: {
      title: "Emergency Auto Locksmith Services in Tel Aviv",
      subtitle: "Professional car key replacement, ignition repair, and lockout services. Available 24/7 for all your automotive security needs.",
      emergency: "Emergency Call",
      services: "Our Services",
      available24: "24/7 Available",
      location: "Tel Aviv Area",
      telAviv: "Tel Aviv",
      expert: "Expert Service",
      professional: "Professional",
      contactCard: {
        title: "Need Help Now?",
        callNow: "Call Now"
      }
    },
    services: {
      title: "Professional Auto Locksmith Services",
      subtitle: "We provide comprehensive automotive locksmith solutions with fast response times and competitive pricing.",
      getService: "Get Service",
      items: {
        carKeys: {
          title: "Car Key Replacement",
          description: "Lost your car keys? We create new keys for all vehicle makes and models, including transponder and smart keys."
        },
        ignition: {
          title: "Ignition Repair",
          description: "Ignition problems? Our experts can repair or replace faulty ignition systems quickly and efficiently."
        },
        lockout: {
          title: "Car Lockout Service",
          description: "Locked out of your car? We provide fast and damage-free unlocking services for all vehicle types."
        },
        transponder: {
          title: "Transponder Programming",
          description: "Professional transponder key programming and reprogramming services for enhanced vehicle security."
        }
      },
      emergency: {
        title: "24/7 Emergency Service",
        description: "Don't let car lock problems ruin your day. Our emergency locksmith service is available around the clock to help you get back on the road.",
        callNow: "Call Emergency Line"
      }
    },
    about: {
      title: "About XKey24",
      subtitle: "Your trusted automotive locksmith in Tel Aviv",
      description: "With years of experience in automotive security, XKey24 provides professional locksmith services throughout Tel Aviv and surrounding areas. We specialize in modern vehicle security systems and offer fast, reliable solutions for all your car key and lock needs.",
      experience: "Years Experience",
      customers: "Happy Customers",
      response: "Avg Response Time",
      features: {
        professional: {
          title: "Professional Service",
          description: "Certified technicians with extensive automotive locksmith training and experience."
        },
        fast: {
          title: "Fast Response",
          description: "Quick arrival times and efficient service to minimize your inconvenience."
        },
        modern: {
          title: "Modern Equipment",
          description: "Latest tools and technology for all vehicle makes and security systems."
        }
      }
    },
    contact: {
      title: "Contact XKey24",
      subtitle: "Get in touch for professional auto locksmith services",
      phone: "Phone",
      address: "Address",
      hours: "Service Hours",
      emergency: "Emergency: 24/7",
      form: {
        name: "Your Name",
        phone: "Phone Number",
        service: "Service Needed",
        message: "Message",
        send: "Send Message",
        placeholder: "Describe your locksmith needs..."
      }
    },
    ourWork: {
      title: "Our Work Portfolio",
      subtitle: "See our professional locksmith work examples from across Tel Aviv and surrounding areas",
      categories: {
        all: "All Work",
        keys: "Key Services", 
        ignition: "Ignition Repair",
        lockout: "Lockout Service",
        transponder: "Transponder Programming"
      },
      completed: "Completed",
      cta: {
        title: "Need Professional Locksmith Service?",
        description: "Join hundreds of satisfied customers who trust XKey24 for their automotive locksmith needs",
        button: "Get Professional Service"
      }
    },
    serviceAreas: {
      title: "Our Service Coverage Areas",
      subtitle: "Professional locksmith services available throughout the greater Tel Aviv metropolitan area with fast response times",
      neighborhoods: "Coverage Areas",
      callForService: "Call for Service",
      stats: {
        areas: "Service Areas",
        avgResponse: "Avg Response",
        availability: "Emergency Service"
      },
      emergency: {
        title: "24/7 Emergency Coverage",
        description: "No matter where you are in the Tel Aviv area, our emergency locksmith service is available around the clock",
        callNow: "Emergency Call"
      }
    },
    serviceAreasDetailed: {
      title: "XKEY24 Auto Locksmith Service Areas Throughout Israel",
      subtitle: "Professional car key programming, lockout assistance, and emergency automotive locksmith services available 24/7 across all of Israel",
      stats: {
        emergency: "Emergency Service",
        cities: "Cities Covered",
        rating: "Google Rating"
      },
      intro: {
        title: "Comprehensive Auto Locksmith Coverage Across Israel",
        text1: "XKEY24 provides professional automotive locksmith services throughout Israel with 24/7 emergency response. Our mobile units are equipped with the latest key programming technology and can reach any location within 30-45 minutes.",
        text2: "Whether you're locked out of your car, need a duplicate key, or require ignition repair, our certified technicians bring professional equipment directly to your location. We specialize in all vehicle makes and models, from European luxury cars to local favorites."
      },
      cityTemplate: {
        title: "Mobile Car Key Service in [city] - 24/7 Auto Locksmith Emergency",
        paragraph1: "XKEY24 provides professional mobile car key services in [city] with same-day response. We specialize in car key duplication with programming, spare key creation, emergency key replacement on-site. Our certified technicians arrive with professional equipment for all vehicle makes including smart keys, transponder keys, and keyless systems.",
        paragraph2: "Lost your car keys in [city]? Our expert mobile locksmiths handle complete car key replacement services: transponder programming, immobilizer recoding, key fob shell replacement and circuit board repair. We work with keyless entry systems, proximity keys, key fob cloning, remote control repair and reprogramming on location.",
        paragraph3: "Emergency mobile locksmith 24/7 in [city]. Urgent car key specialist available around the clock. We unlock vehicles without damage and create replacement keys on-site. Affordable car key cutting service, key fob battery replacement, professional key programming. Google 5-star rated service with warranty coverage on all work."
      },
      finalCta: {
        title: "Need Emergency Auto Locksmith Service?",
        description: "Don't let car key problems ruin your day. XKEY24's certified technicians are standing by 24/7 to provide professional automotive locksmith services anywhere in Israel.",
        googleRating: "5.0 Stars on Google"
      }
    },
    testimonials: {
      title: "What Our Customers Say",
      subtitle: "Read real reviews from satisfied customers who trust XKey24 for their automotive locksmith needs",
      cta: {
        title: "Join Our Satisfied Customers",
        description: "Experience the same professional service that earned us these 5-star reviews",
        button: "Get Professional Service"
      }
    },
    footer: {
      description: "Professional auto locksmith services in Tel Aviv. Specializing in car keys, ignition repair, and emergency lockout assistance.",
      quickLinks: "Quick Links",
      services: "Services",
      contact: "Contact Info",
      rights: "All rights reserved"
    }
  },
  he: {
    tagline: "מומחה מנעולן רכב",
    nav: {
      services: "שירותים",
      about: "אודות",
      ourWork: "העבודות שלנו",
      areas: "אזורי שירות",
      contact: "צור קשר"
    },
    hero: {
      title: "שירותי מנעולן רכב חירום בתל אביב",
      subtitle: "החלפת מפתחות רכב מקצועית, תיקון התנעה ושירותי פתיחת רכב. זמינים 24/7 לכל צרכי האבטחה הרכבית שלכם.",
      emergency: "קריאת חירום",
      services: "השירותים שלנו",
      available24: "זמינים 24/7",
      location: "אזור תל אביב",
      telAviv: "תל אביב",
      expert: "שירות מומחה",
      professional: "מקצועי",
      contactCard: {
        title: "צריכים עזרה עכשיו?",
        callNow: "התקשרו עכשיו"
      }
    },
    services: {
      title: "שירותי מנעולן רכב מקצועיים",
      subtitle: "אנו מספקים פתרונות מנעולנות רכב מקיפים עם זמני תגובה מהירים ומחירים תחרותיים.",
      getService: "קבלת שירות",
      items: {
        carKeys: {
          title: "החלפת מפתחות רכב",
          description: "איבדתם את מפתחות הרכב? אנו יוצרים מפתחות חדשים לכל סוגי הרכבים, כולל מפתחות טרנספונדר וחכמים."
        },
        ignition: {
          title: "תיקון התנעה",
          description: "בעיות התנעה? המומחים שלנו יכולים לתקן או להחליף מערכות התנעה תקולות במהירות וביעילות."
        },
        lockout: {
          title: "שירות פתיחת רכב",
          description: "ננעלתם מחוץ לרכב? אנו מספקים שירותי פתיחה מהירים וללא נזק לכל סוגי הרכבים."
        },
        transponder: {
          title: "תכנות טרנספונדר",
          description: "שירותי תכנות וחזרה על תכנות מפתחות טרנספונדר מקצועיים לאבטחת רכב משופרת."
        }
      },
      emergency: {
        title: "שירות חירום 24/7",
        description: "אל תתנו לבעיות מנעול רכב להרוס לכם את היום. שירות המנעולן החירום שלנו זמין מסביב לשעון כדי לעזור לכם לחזור לדרך.",
        callNow: "התקשרו לקו החירום"
      }
    },
    about: {
      title: "אודות XKey24",
      subtitle: "המנעולן הרכבי המהימן שלכם בתל אביב",
      description: "עם שנים של ניסיון באבטחת רכבים, XKey24 מספקת שירותי מנעולנות מקצועיים ברחבי תל אביב והסביבה. אנו מתמחים במערכות אבטחת רכב מודרניות ומציעים פתרונות מהירים ואמינים לכל צרכי המפתחות והמנעולים שלכם.",
      experience: "שנות ניסיון",
      customers: "לקוחות מרוצים",
      response: "זמן תגובה ממוצע",
      features: {
        professional: {
          title: "שירות מקצועי",
          description: "טכנאים מוסמכים עם הכשרה נרחבת וניסיון במנעולנות רכב."
        },
        fast: {
          title: "תגובה מהירה",
          description: "זמני הגעה מהירים ושירות יעיל כדי למזער את אי הנוחות שלכם."
        },
        modern: {
          title: "ציוד מודרני",
          description: "כלים וטכנולוגיות חדישים לכל סוגי הרכבים ומערכות האבטחה."
        }
      }
    },
    contact: {
      title: "צור קשר עם XKey24",
      subtitle: "צרו קשר לשירותי מנעולן רכב מקצועיים",
      phone: "טלפון",
      address: "כתובת",
      hours: "שעות שירות",
      emergency: "חירום: 24/7",
      form: {
        name: "השם שלכם",
        phone: "מספר טלפון",
        service: "השירות הנדרש",
        message: "הודעה",
        send: "שלח הודעה",
        placeholder: "תארו את צרכי המנעולנות שלכם..."
      }
    },
    ourWork: {
      title: "תיק העבודות שלנו",
      subtitle: "צפו בדוגמאות עבודה מקצועיות של מנעולנות רכב ברחבי תל אביב והסביבה",
      categories: {
        all: "כל העבודות",
        keys: "שירותי מפתחות",
        ignition: "תיקון התנעה",
        lockout: "שירות פתיחת רכב",
        transponder: "תכנות טרנספונדר"
      },
      completed: "הושלם",
      cta: {
        title: "זקוקים לשירות מנעולן מקצועי?",
        description: "הצטרפו למאות לקוחות מרוצים הסומכים על XKey24 לצרכי המנעולנות הרכבית שלהם",
        button: "קבלו שירות מקצועי"
      }
    },
    serviceAreas: {
      title: "אזורי השירות שלנו",
      subtitle: "שירותי מנעולנות מקצועיים זמינים ברחבי האזור המטרופוליני של תל אביב עם זמני תגובה מהירים",
      neighborhoods: "אזורי כיסוי",
      callForService: "התקשרו לשירות",
      stats: {
        areas: "אזורי שירות",
        avgResponse: "תגובה ממוצעת",
        availability: "שירות חירום"
      },
      emergency: {
        title: "כיסוי חירום 24/7",
        description: "לא משנה איפה אתם באזור תל אביב, שירות המנעולן החירום שלנו זמין מסביב לשעון",
        callNow: "קריאת חירום"
      }
    },
    serviceAreasDetailed: {
      title: "אזורי שירות XKEY24 מנעולן רכב ברחבי ישראל",
      subtitle: "שירותי תכנות מפתחות רכב מקצועיים, עזרה בנעילה חירום ושירותי מנעולן רכב זמינים 24/7 ברחבי ישראל",
      stats: {
        emergency: "שירות חירום",
        cities: "ערים מכוסות",
        rating: "דירוג גוגל"
      },
      intro: {
        title: "כיסוי מנעולן רכב מקיף ברחבי ישראל",
        text1: "XKEY24 מספקת שירותי מנעולן רכב מקצועיים ברחבי ישראל עם מענה חירום 24/7. היחידות הניידות שלנו מצוידות בטכנולוגיית תכנות מפתחות מתקדמת ויכולות להגיע לכל מקום תוך 30-45 דקות.",
        text2: "בין אם אתם נעולים מחוץ לרכב, צריכים מפתח כפול או זקוקים לתיקון התנעה, הטכנאים המוסמכים שלנו מביאים ציוד מקצועי ישירות למיקומכם. אנו מתמחים בכל סוגי הרכבים, ממכוניות יוקרה אירופאיות ועד לדגמים מקומיים פופולריים."
      },
      cityTemplate: {
        title: "יצור מפתחות רכב עם הגעה ב[city] - מומחה מפתחות 24/7",
        paragraph1: "XKEY24 - המומחה הגעה ויצור מפתחות רכב ב[city]. מספקים שירות מקיף: העתקת מפתח צ'יפ עם תכנות, יצור מפתח רזרבי, מפתח חירום במקום. הגעה ביום הפנייה עם ציוד מקצועי לכל סוגי הרכבים ומפתחות חכמים.",
        paragraph2: "איבדתם מפתחות הרכב ב[city]? המומחים המוסמכים שלנו מבצעים יצור מפתח לרכב עם הגעה: תכנות טרנספונדר, קידוד מחדש של אימובילייזר, החלפת מעטה מפתח והלחמה של לוחות. עובדים עם מפתחות keyless ו-proximity, שכפול מפתח שלט, תיקון ותכנות מחדש של שלט.",
        paragraph3: "הגעה דחופה מומחה מפתחות 24/7 ב[city]. מומחה חירום למפתחות רכב זמין מסביב לשעון. פותחים רכב ללא נזקים ויוצרים מפתח עם הגעה במקום. יצור מפתח רכב במחיר נוח עם הגעה, החלפת סוללת שלט. דירוג 5 כוכבים בגוגל, אחריות על כל השירותים."
      },
      finalCta: {
        title: "זקוקים לשירות מנעולן רכב חירום?",
        description: "אל תתנו לבעיות מפתחות רכב להרוס לכם את היום. הטכנאים המוסמכים של XKEY24 עומדים כוננות 24/7 כדי לספק שירותי מנעולן רכב מקצועיים בכל מקום בישראל.",
        googleRating: "5.0 כוכבים בגוגל"
      }
    },
    testimonials: {
      title: "מה הלקוחות שלנו אומרים",
      subtitle: "קראו ביקורות אמיתיות מלקוחות מרוצים הסומכים על XKey24 לצרכי המנעולנות הרכבית שלהם",
      cta: {
        title: "הצטרפו ללקוחות המרוצים שלנו",
        description: "חוו את אותו שירות מקצועי שזיכה אותנו בביקורות 5 כוכבים אלה",
        button: "קבלו שירות מקצועי"
      }
    },
    footer: {
      description: "שירותי מנעולן רכב מקצועיים בתל אביב. מתמחים במפתחות רכב, תיקון התנעה ועזרה חירום בפתיחת רכבים.",
      quickLinks: "קישורים מהירים",
      services: "שירותים",
      contact: "פרטי קשר",
      rights: "כל הזכויות שמורות"
    }
  },
  ru: {
    tagline: "Эксперт автослесарь",
    nav: {
      services: "Услуги",
      about: "О нас",
      ourWork: "Наши работы",
      areas: "Зоны обслуживания",
      contact: "Контакты"
    },
    hero: {
      title: "Экстренные услуги автослесаря в Тель-Авиве",
      subtitle: "Профессиональная замена автомобильных ключей, ремонт зажигания и услуги вскрытия замков. Доступны 24/7 для всех ваших потребностей в автомобильной безопасности.",
      emergency: "Экстренный вызов",
      services: "Наши услуги",
      available24: "Доступны 24/7",
      location: "Район Тель-Авива",
      telAviv: "Тель-Авив",
      expert: "Экспертное обслуживание",
      professional: "Профессионально",
      contactCard: {
        title: "Нужна помощь сейчас?",
        callNow: "Звонить сейчас"
      }
    },
    services: {
      title: "Профессиональные услуги автослесаря",
      subtitle: "Мы предоставляем комплексные решения автомобильной слесарной службы с быстрым временем отклика и конкурентоспособными ценами.",
      getService: "Получить услугу",
      items: {
        carKeys: {
          title: "Замена автомобильных ключей",
          description: "Потеряли ключи от машины? Мы изготавливаем новые ключи для всех марок и моделей автомобилей, включая транспондерные и умные ключи."
        },
        ignition: {
          title: "Ремонт зажигания",
          description: "Проблемы с зажиганием? Наши эксперты могут быстро и эффективно отремонтировать или заменить неисправные системы зажигания."
        },
        lockout: {
          title: "Служба вскрытия автомобилей",
          description: "Заперлись в машине? Мы предоставляем быстрые и безопасные услуги разблокировки для всех типов транспортных средств."
        },
        transponder: {
          title: "Программирование транспондера",
          description: "Профессиональные услуги программирования и перепрограммирования транспондерных ключей для повышенной безопасности автомобиля."
        }
      },
      emergency: {
        title: "Круглосуточная экстренная служба",
        description: "Не позволяйте проблемам с автомобильными замками испортить ваш день. Наша экстренная слесарная служба доступна круглосуточно, чтобы помочь вам вернуться в дорогу.",
        callNow: "Вызвать экстренную службу"
      }
    },
    about: {
      title: "О XKey24",
      subtitle: "Ваш надежный автомобильный слесарь в Тель-Авиве",
      description: "Имея многолетний опыт в области автомобильной безопасности, XKey24 предоставляет профессиональные слесарные услуги по всему Тель-Авиву и окрестностям. Мы специализируемся на современных системах безопасности транспортных средств и предлагаем быстрые, надежные решения для всех ваших потребностей в автомобильных ключах и замках.",
      experience: "Лет опыта",
      customers: "Довольных клиентов",
      response: "Среднее время отклика",
      features: {
        professional: {
          title: "Профессиональное обслуживание",
          description: "Сертифицированные техники с обширной подготовкой и опытом в области автомобильной слесарной службы."
        },
        fast: {
          title: "Быстрый отклик",
          description: "Быстрое время прибытия и эффективное обслуживание для минимизации ваших неудобств."
        },
        modern: {
          title: "Современное оборудование",
          description: "Новейшие инструменты и технологии для всех марок автомобилей и систем безопасности."
        }
      }
    },
    contact: {
      title: "Связаться с XKey24",
      subtitle: "Свяжитесь с нами для профессиональных услуг автослесаря",
      phone: "Телефон",
      address: "Адрес",
      hours: "Часы работы",
      emergency: "Экстренно: 24/7",
      form: {
        name: "Ваше имя",
        phone: "Номер телефона",
        service: "Необходимая услуга",
        message: "Сообщение",
        send: "Отправить сообщение",
        placeholder: "Опишите ваши потребности в слесарных услугах..."
      }
    },
    ourWork: {
      title: "Портфолио наших работ",
      subtitle: "Посмотрите примеры профессиональных слесарных работ по всему Тель-Авиву и окрестностям",
      categories: {
        all: "Все работы",
        keys: "Услуги ключей",
        ignition: "Ремонт зажигания", 
        lockout: "Служба вскрытия",
        transponder: "Программирование транспондера"
      },
      completed: "Выполнено",
      cta: {
        title: "Нужны профессиональные слесарные услуги?",
        description: "Присоединяйтесь к сотням довольных клиентов, которые доверяют XKey24 свои потребности в автомобильных слесарных услугах",
        button: "Получить профессиональный сервис"
      }
    },
    serviceAreas: {
      title: "Наши зоны обслуживания",
      subtitle: "Профессиональные слесарные услуги доступны по всей столичной области Тель-Авива с быстрым временем реагирования",
      neighborhoods: "Зоны покрытия",
      callForService: "Вызвать службу",
      stats: {
        areas: "Зоны обслуживания",
        avgResponse: "Среднее время",
        availability: "Служба экстренного реагирования"
      },
      emergency: {
        title: "Круглосуточное экстренное покрытие",
        description: "Где бы вы ни находились в районе Тель-Авива, наша экстренная слесарная служба доступна круглосуточно",
        callNow: "Экстренный вызов"
      }
    },
    serviceAreasDetailed: {
      title: "Зоны обслуживания автослесаря XKEY24 по всему Израилю",
      subtitle: "Профессиональные услуги программирования автоключей, помощь при блокировке и экстренные автослесарные услуги доступны 24/7 по всему Израилю",
      stats: {
        emergency: "Экстренная служба",
        cities: "Охваченные города",
        rating: "Рейтинг Google"
      },
      intro: {
        title: "Комплексное покрытие автослесарных услуг по всему Израилю",
        text1: "XKEY24 предоставляет профессиональные автослесарные услуги по всему Израилю с круглосуточным экстренным реагированием. Наши мобильные бригады оснащены новейшими технологиями программирования ключей и могут добраться до любого места в течение 30-45 минут.",
        text2: "Независимо от того, заперлись ли вы в машине, нужен ли дубликат ключа или требуется ремонт зажигания, наши сертифицированные техники привозят профессиональное оборудование прямо к вашему местоположению. Мы специализируемся на всех марках и моделях автомобилей, от европейских люксовых до популярных местных брендов."
      },
      cityTemplate: {
        title: "Изготовление ключей авто с выездом в [city] - Мастер по ключам 24/7",
        paragraph1: "XKEY24 - профессиональный мастер по изготовлению ключей авто с выездом в [city]. Специализируемся на дубликате чип-ключа с программированием, изготовлении запасного ключа, аварийном ключе. Срочный выезд мастера в день обращения с современным оборудованием для всех марок автомобилей.",
        paragraph2: "Потерял ключи от машины в [city]? Выполняем изготовление ключа для автомобиля с выездом: программирование транспондера, перекодировку иммобилайзера, замену корпуса ключа. Работаем с keyless и proximity ключами, клонирование ключа брелока, ремонт пульта на месте.",
        paragraph3: "Экстренный мастер по ключам авто 24/7 в [city]. Аварийный выезд, открытие машины без повреждений и изготовление ключа с выездом. Сделать ключ авто недорого, замена батареи брелока, перепайка плат. 5-звездочный рейтинг Google, гарантия качества."
      },
      finalCta: {
        title: "Нужна экстренная автослесарная служба?",
        description: "Не позволяйте проблемам с автоключами испортить ваш день. Сертифицированные техники XKEY24 готовы 24/7 предоставить профессиональные автослесарные услуги в любой точке Израиля.",
        googleRating: "5.0 звезд в Google"
      }
    },
    testimonials: {
      title: "Что говорят наши клиенты",
      subtitle: "Читайте реальные отзывы довольных клиентов, которые доверяют XKey24 свои потребности в автомобильных слесарных услугах",
      cta: {
        title: "Присоединяйтесь к нашим довольным клиентам",
        description: "Получите тот же профессиональный сервис, который принес нам эти 5-звездочные отзывы",
        button: "Получить профессиональный сервис"
      }
    },
    footer: {
      description: "Профессиональные услуги автослесаря в Тель-Авиве. Специализируемся на автомобильных ключах, ремонте зажигания и экстренной помощи при вскрытии замков.",
      quickLinks: "Быстрые ссылки",
      services: "Услуги",
      contact: "Контактная информация",
      rights: "Все права защищены"
    }
  }
};